import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";

function TimeColumn({ scheduled, revised, city, className = "" }) {
  const showRevised = Boolean(revised && revised !== scheduled);
  const displayTime = showRevised ? revised : scheduled;

  return (
    <div className={`fs-route-listing__time-col ${className}`}>
      {showRevised && scheduled ? (
        <span className="fs-route-listing__time-scheduled">{scheduled}</span>
      ) : null}
      {displayTime ? <span className="fs-route-listing__time-actual">{displayTime}</span> : null}
      {city ? <span className="fs-route-listing__city">{city}</span> : null}
    </div>
  );
}

export default function FlightStatusListingCard({ card }) {
  if (!card) return null;
  const handleSelect = () => {
    if (card?.selectUrl && typeof window !== "undefined") {
      window.location.href = card.selectUrl;
    }
  };

  return (
    <li className="fs-route-listing__card">
      <div className="fs-route-listing__airline">
        {card.iconUrl ? (
          <img
            className="fs-route-listing__airline-logo"
            src={card.iconUrl}
            alt={card.airlineName || card.airlineCode}
            loading="lazy"
          />
        ) : null}
        <div className="fs-route-listing__airline-text">
          <span className="fs-route-listing__airline-name">{transformToHtml(card.airlineName)}</span>
          {card.flightNumber ? (
            <span className="fs-route-listing__flight-no">{transformToHtml(card.flightNumber)}</span>
          ) : null}
          {card.operatedBy ? (
            <span className="fs-route-listing__operated-by">{transformToHtml(card.operatedBy)}</span>
          ) : null}
        </div>
      </div>

      <TimeColumn
        scheduled={card.scheduledDepartureTime}
        revised={card.revisedDepartureTime}
        city={card.depCityName}
      />

      <div className="fs-route-listing__duration">
        {card.duration ? (
          <span className="fs-route-listing__duration-text">{transformToHtml(card.duration)}</span>
        ) : null}
        <span className="fs-route-listing__duration-bar" aria-hidden />
      </div>

      <TimeColumn
        scheduled={card.scheduledArrivalTime}
        revised={card.revisedArrivalTime}
        city={card.arrCityName}
        className="fs-route-listing__time-col--end"
      />

      {card.statusText ? (
        <span
          className="fs-route-listing__status"
          style={{ background: card.statusGradient }}
        >
          {transformToHtml(card.statusText)}
        </span>
      ) : null}

      <button type="button" className="fs-route-listing__select" onClick={handleSelect}>
        {transformToHtml(card.selectLabel || "SELECT")}
      </button>
    </li>
  );
}
